// import React from 'react'

// const Disclaimer = () => {
//   return (
//     <div>
//       <div className="row mt-5 p-4">
//         <div className="col-md-10 offset-md-1">
//           <h1 style={{ color: "#073f41", textAlign: "center" }}>Disclaimer</h1>
//           <h4 className="mt-5">General Information</h4>
//           <p style={{ fontSize: 20 }}>
//             The information provided by Mohit-Brothers on our website is for general
//             informational purposes only. While we strive for accuracy, we make no
//             guarantees about the reliability, suitability, or availability of any
//             products, services, or information.
//           </p>
//           <h4 className="mt-4">Product Information</h4>
//           <p style={{ fontSize: 20 }}>
//             Descriptions, images, and availability of products like blazers,
//             Jodhpuris, and Indo-Westerns, etc. are subject to change without notice.
//             We aim to display product colors accurately but cannot guarantee monitor
//             variations.
//           </p>
//           <h4 className="mt-4">External Links Disclaimer</h4>
//           <p style={{ fontSize: 20 }}>
//             Our website may contain links to third-party sites. We do not control or
//             take responsibility for their content or practices.
//           </p>
//           <h4 className="mt-4">Limitation of Liability</h4>
//           <p style={{ fontSize: 20 }}>
//             Mohit-Brothers is not liable for any damages arising from the use of our
//             site, including loss of data or profits.
//           </p>
//           <h4 className="mt-4">Errors and Omissions</h4>
//           <p style={{ fontSize: 20 }}>
//             We are not responsible for inaccuracies and reserve the right to update or
//             correct any errors without notice.
//           </p>
//           <h4 className="mt-4">No Professional Advice</h4>
//           <p style={{ fontSize: 20 }}>
//             Content is for general purposes and not professional advice.
//           </p>
//           <h4 className="mt-4">Affiliate Disclaimer</h4>
//           <p style={{ fontSize: 20 }}>
//             Some links may be affiliate links, and we may earn commissions. This does
//             not affect the prices you pay.
//           </p>
//           <h4 className="mt-4">Contact Us</h4>
//           <p style={{ fontSize: 20 }}>
//             If you have any questions regarding this disclaimer or need further
//             clarification, you can contact us at:
//           </p>
//           <p style={{ fontSize: 20 }}>
//             Email: <a href="">Maa kamakhya puja seva.com</a>{" "}
//           </p>
//           <p style={{ fontSize: 20 }}>
//             Website:{" "}
//             <a href="Maa kamakhya puja seva.com/" target="_blank">
//               Maa kamakhya puja seva.com/
//             </a>{" "}
//           </p>
//         </div>
//       </div>
//     </div>
//   )
// }

// export default Disclaimer














import React from "react";

const Disclaimer = () => {
  return (
    <div>
      <div className="row  p-4">
        <div className="col-md-10 offset-md-1">
          
           <div class="disclaimer-container-custom">
    <div class="disclaimer-title-custom">Disclaimer :</div>
    <ul class="disclaimer-list-custom">
      <li>This is a personal spiritual website of Goddess Maa Kamakhya by Jitul Sarmah . We have no relation with the  Maa Kamakhya Temple Committee whatsoever.</li>
      <li>This website is solely maintained by Mata's Priest  Jitul Sarmah .</li>
      <li>This Website is not Maintained by Maa Kamakhya Temple Committee (Maa Kamakhya temple).</li>
      <li>If you have any Pre-Known Priest at the Maa Kamakhya Temple, then please contact him to worship your Puja.</li>
    </ul>
  </div>
        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
